<template>   
    <div class="banner-top-2 px-mob" v-if="enableDiscount">
        <rangeSlider v-if="enableDiscount"></rangeSlider>
    </div>
    <div class="wrap-plan flex-column py-2 px-mob my-6 d-flex justify-center" :class="{'add-border': !enableDiscount }">
        <div>
            <h2 class="mb-5 mb-6 text-center">What meals do you want each day?</h2>
        </div>
        <div class="wrap-plan-menu-row d-flex flex-column">
            <div class="plan-menu-item d-flex" v-for="(menu, i) in menus" :key="i">
                <div class="plan-menu-item-title"><h4>{{ menu.title }}</h4><p v-if="menu.description">{{ menu.description }}</p></div>
                <div class="plan-menu-item-condivol d-flex row">
                    <div class="btn-update-count minus" @click="updateCounts(i, '-')"><span></span></div>
                    <div class="item-count" >{{ menu.count >= 0 ? menu.count : 1 }}</div>
                    <div class="btn-update-count plus" @click="updateCounts(i, '+')"><span></span></div>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex justify-center my-6 pt-6 px-mob">
        <button class="btn-main-app" :disabled="btnDisabled" @click="nextPage">See your weekly meal plan</button>
    </div>       
</template>

<script>
import Cookies from 'js-cookie'
import rangeSlider from '../../components/rangeSlider.vue';

export default {
    name: 'step-5',
    components: {
        rangeSlider,     
    },
    data() {
        return {
            btnDisabled: true,
            setNextPage: true,
        }
    },
    computed: {
        menus() {                     
            return this.$store.getters.getMenus;
        },
        wizardMenu() {
            return this.$store.getters.wizardMenu;
        },
        itemsOrder() {
            return this.$store.getters.itemsOrder;
        },
        lastStep() {
            return this.$store.getters.lastStep;
        },
        protein() {
            return this.$store.getters.proteinsType;
        },
        allergies() {
            return this.$store.getters.getAllergies;
        },
        enableDiscount() {
            return this.$store.getters.enableDiscount;
        },
        plansData() {
            return this.$store.getters.basicPlans;
        },
    },
    methods: {
        nextPage() {            
            Cookies.set('lastStep', 1, { expires: 3600 });
            if ( this.plansData && this.plansData.length > 0 ) {
                this.$store.commit('setBasicPlans', this.plansData);
            }
            
            this.wizardMenu[4].isActive = this.wizardMenu[4].lastItem = false;
            this.wizardMenu[5].isActive = this.wizardMenu[5].lastItem = true;
            this.$store.commit('setWizardMenu', this.wizardMenu );
        },
        updateCounts(i, math) {

            this.menus.forEach((item, index) => {
                if(index == i) {
                    if(math == '-' && item.count > 0) {
                        item.count--;
                    }

                    if (math == '+' && item.count >= 0) {
                        item.count++;
                    }                    
                }
                
            });

            this.$store.commit('setLastStep', false);

            this.setClassActive();
        },
        setClassActive() {

            if (this.menus[0].count > 0 || this.menus[1].count > 0 || this.menus[2].count > 0) {

                this.btnDisabled = false;

                Cookies.set('breakfastCount', this.menus[0].count, { expires: 3600 });
                Cookies.set('mainCount', this.menus[1].count, { expires: 3600 });
                Cookies.set('snacksCount', this.menus[2].count, { expires: 3600 });

            } 
            if (this.menus[0].count == 0 && this.menus[1].count == 0 && this.menus[2].count == 0) {

                this.btnDisabled = true;
            }
        },
    },
    async beforeMount() { 
        this.$store.dispatch('getProducts', { mealType: 'mains', allergies: this.allergies, plan: this.itemsOrder.plan.cat_prod_id, protein: this.itemsOrder.protein.slug  });
        this.$store.dispatch('getProducts', { mealType: 'breakfast', allergies: this.allergies, plan: this.itemsOrder.plan.cat_prod_id, protein: this.itemsOrder.protein.slug  });
        this.$store.dispatch('getProducts', { mealType: 'snacks', allergies: this.allergies, plan: this.itemsOrder.plan.cat_prod_id, protein: this.itemsOrder.protein.slug  });
        
        let breakfastData = 0;
        let mainCount = 0;
        let snacksCount = 0;
        
        if( this.menus[0].count == 0 ) {
            breakfastData = 0;
        } else if (Cookies.get('breakfastCount')) {
            breakfastData = Cookies.get('breakfastCount');
        }

        if (breakfastData) {
            this.menus[0].count = breakfastData;
        }

        if (this.menus[1].count == 0) {
            mainCount = 0;
        } else if (Cookies.get('mainCount')) {
            mainCount = Cookies.get('mainCount');
        }

        if ( mainCount ) {
            this.menus[1].count = mainCount;
        }
                
        if (Cookies.get('snacksCount')) {
            snacksCount = Cookies.get('snacksCount');
        } else if (this.menus[2].count == 0) {
            snacksCount = 0;
        }
        
        if (snacksCount) {
            this.menus[2].count = snacksCount;
        }

        if ( this.setNextPage && (this.menus[0].count >= 0 || this.menus[1].count >= 0 || this.menus[2].count >= 0) && Cookies.get('lastStep') ) {
            this.setNextPage = false;
            if( this.lastStep ) {
                if (this.wizardMenu[4].view == false) {
                    this.wizardMenu[4].view = true;                    
                    this.nextPage();                
                }
                
            } 
            
            this.btnDisabled = false;

            this.$store.commit('setLastStep', false);
        } 

        if (this.menus[0].count == 0 && this.menus[1].count == 0 && this.menus[2].count == 0) {
            this.btnDisabled = true;
        } else {
            this.btnDisabled = false;
        }

    },
}
</script>

<style lang="stylus">
.add-border {
    border-top: 2px solid #e1e6ef;
    padding-top: 32px!important;
}
    .table-meal-plan {
        background: #F1F3F9;
        border-width: 2px 0px;
        border-style: solid;
        border-color: #E1E6EF;
        h2 {
            font-size: 18px;
        }
    }

</style>
<style scoped lang="stylus">

.table-wrap ul {
        list-style: none;

        li {
            font-family: 'Manrope', sans-serif;
            font-style: normal;
            font-weight: 800;
            font-size: 16px;
            line-height: 19px;
            display: flex;
            align-items: center;
            text-align: center;
            letter-spacing: -0.02em;
            color: #1d2433;
            border-bottom: 3px solid #1d2433;
            transition-duration: 0.4s;
            cursor: pointer;

            @media screen and (max-width: 767px) {
                font-size: 14px;
            }

            &:hover,
            &.active {
                color: #685bc7;
                border-bottom: 3px solid #685bc7;
                transition-duration: 0.4s;
            }
        }
    }
    .table-meal-plan.border-bottom-none {
        border-bottom: none;
        background: none;
    }
    .banner-top-2 {
        padding: 13px 0;
    } 
    .wrap-plan-menu-row {
        max-width: 450px;
        margin: auto;
        width: 100%;
        gap: 1.5rem;
    }
    .btn-main-app {
        color: #fff;
    }
    .plan-menu-item {
        align-items: center;

        &-title {
            width: calc(100% - 195px);

            h4 {
                font-family: 'Manrope', sans-serif;
                font-style: normal;
                font-weight: 800;
                font-size: 18px;
                line-height: 25px;
                color: #1D2433;
            }

            p {
                font-family: 'Manrope', sans-serif;
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 19px;
                color: #685BC7;

                @media screen and (max-width: 767px) {
                    font-size: 14px;
                }
            }
        }
    }
    .plan-menu-item-condivol
        display: grid;
        gap: 1rem;
        width: 195px;
        & > div
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border-radius: 10px;

                span {
                    width: 25.5px;
                    height: 25px;
                    background-size: cover;
                }
                &.minus {
                    span {
                        background: url(/src/assets/images/icons/minus.svg)
                    }
                }
                &.plus {
                    span {
                        background: url(/src/assets/images/icons/plus.svg)
                    }
                }
                &.item-count
                    width: 63px;
                    height: 50px;
                    background: #FFFFFF;
                    border: 2px solid #E1E6EF;                    
                    letter-spacing: -0.02em;
                    color: #201747;
                    font-family: 'Manrope';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 24px;
                    line-height: 33px;
                &.btn-update-count
                    background: #685BC7;     
                    padding: 10px 16px; 
                    width: 50px;
                    height: 50px;
                    divansition-duration: .4s;
                    cursor: pointer 
                    &:hover
                        background: #50469a;

</style>